export default __webpack_public_path__ + "static/media/award2.c0970ff3.jpg";